// ============================================================
// Sidebar — Navigation, Brand, Lock-Hinweis
// ============================================================

import { Icon } from '../icons';
import { readableOnBrand, CO } from '../theme';
import { useApp } from '../store';
import type { IconName, RouteKey } from '../types';

const NAV: { k: RouteKey; l: string; d: string; ic: IconName }[] = [
  { k: 'uebersicht', l: 'Übersicht', d: 'Finanzielle Transparenz auf einen Blick', ic: 'grid' },
  { k: 'zeitverlauf', l: 'Zeitverlauf', d: 'Einsatz und Auszahlung über die Zeit', ic: 'line' },
  { k: 'spielarten', l: 'Spielarten', d: 'Neutraler Vergleich der Spielarten', ic: 'bars' },
  { k: 'muster', l: 'Muster & Serien', d: 'Historische Muster im importierten Datensatz', ic: 'dots' },
  { k: 'einzelbuchungen', l: 'Einzelbuchungen', d: 'Alle gebuchten Einträge im Detail', ic: 'list' },
  { k: 'datenimport', l: 'Datenimport', d: 'Datensatz prüfen oder ersetzen', ic: 'down' },
];

export function Sidebar() {
  const { route, setRoute } = useApp();
  const brand = CO.sidebar;
  const T = readableOnBrand(brand);

  return (
    <aside
      style={{
        width: 260,
        flex: '0 0 260px',
        background: brand,
        color: T.fg,
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
      }}
    >
      <div style={{ padding: '22px 22px 18px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 11 }}>
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: 9,
              background: T.fg,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flex: '0 0 40px',
            }}
          >
            <span
              style={{
                fontWeight: 700,
                fontSize: 18,
                color: brand,
                letterSpacing: '-.5px',
              }}
            >
              ML
            </span>
          </div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 15, lineHeight: 1.1, color: T.fg }}>Mein Lotto</div>
            <div style={{ fontSize: 11, color: T.fg60 }}>Logo-Platzhalter</div>
          </div>
        </div>
        <div style={{ marginTop: 16, fontSize: 13, fontWeight: 600, color: T.fg }}>Spielanalyse</div>
        <div style={{ fontSize: 11.5, color: T.fg60 }}>Private Auswertung</div>
      </div>

      <nav style={{ padding: '4px 12px', flex: 1 }}>
        {NAV.map((it) => {
          const active = route === it.k;
          return (
            <button
              key={it.k}
              onClick={() => setRoute(it.k)}
              aria-current={active ? 'page' : undefined}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 11,
                width: '100%',
                textAlign: 'left',
                border: 'none',
                background: active ? T.chip : 'transparent',
                color: active ? T.fg : T.fg80,
                padding: '10px 12px',
                borderRadius: 8,
                marginBottom: 3,
                fontSize: 13.5,
                fontWeight: active ? 600 : 500,
                position: 'relative',
                transition: 'background .15s',
                cursor: 'pointer',
              }}
            >
              {active ? (
                <span
                  style={{
                    position: 'absolute',
                    left: -12,
                    top: 8,
                    bottom: 8,
                    width: 3,
                    background: T.fg,
                    borderRadius: '0 3px 3px 0',
                  }}
                />
              ) : null}
              <Icon name={it.ic} color={active ? T.fg : T.fg80} size={18} />
              <span>{it.l}</span>
            </button>
          );
        })}
      </nav>

      <div
        style={{
          padding: '16px 20px',
          borderTop: `1px solid ${T.line}`,
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
        }}
      >
        <div style={{ display: 'flex', gap: 9, alignItems: 'flex-start' }}>
          <Icon name="lock" color={T.fg60} size={15} />
          <div style={{ fontSize: 11.5, lineHeight: 1.45, color: T.fg60 }}>
            Daten werden nur lokal in diesem Browser gespeichert. Keine Übertragung an einen Server.
          </div>
        </div>
        <div style={{ fontSize: 10.5, lineHeight: 1.4, color: T.fg60, fontStyle: 'italic' }}>
          Privatprojekt — nicht offiziell, keine Verbindung zu einem Lotterie-Anbieter.
        </div>
      </div>
    </aside>
  );
}
